import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
// import way from '../vue_fun.js'
// Vue.use(way)
import VueEasytable from "vue-easytable";
// 引入样式
import "vue-easytable/libs/theme-default/index.css";
import "vue-easytable/libs/theme-default/ve-pagination.css";
import myUpload from './components/myUpload/my-upload.vue';
import myUploads from './components/myUpload/my-uploads.vue';
import myUploadTwo from './components/myUpload/my-uploadTwo.vue';
import myUpload3 from './components/myUpload/my-upload3.vue';
import myUploadVideo from './components/myUpload/my-uploadVideo.vue';
Vue.component('myUploads', myUploads)
Vue.component('myUpload', myUpload)
Vue.component('myUploadTwo', myUploadTwo)
Vue.component('myUpload3', myUpload3)
Vue.component('myUploadVideo', myUploadVideo)
Vue.use(VueEasytable);
import { VeLocale } from "vue-easytable";
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false;
Vue.prototype.$veLocale = VeLocale;
let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
// npm install vue-aplayer --save
//console.log(flag); 
let flagShow = false
if(flag){
    flagShow = true
}
router.beforeEach((to, from, next) => {
    //debugger
    //console.log(to,from);
    if (to.path === '/Index') {
        next();
    } 
    
});
// //console.log(way)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
